/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { TableRow, TableCell, Grid } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { Modal, TableAction } from "App/Component/ui";
import { instance3 } from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { useDatatables } from "App/hooks";
import { FreezeTableClient } from "components/organism";

export default function ModalJasaSpesialis({ setShowModal, jasaID }) {
  const [rows, setRows] = useState([]);
  const [rowsSpesialisMapping, setRowsSpesialisMapping] = useState([]);

  const setNewData = async () => {
    const res = await getSpesialisNotInJasa(jasaID);
    if (res.state) {
      setRows(res.data);
    }
  };

  const setNewDataMapping = async () => {
    const res = await getSpesialisInJasa(jasaID);
    if (res.state) {
      setRowsSpesialisMapping(res.data);
    }
  };

  useEffect(() => {
    setNewData();
  }, [jasaID]);

  useEffect(() => {
    setNewDataMapping();
  }, [jasaID]);

  const setNewAll = async () => {
    await setNewData();
    await setNewDataMapping();
  };

  return (
    <Modal title='Jasa Spesialis' width={"70%"} show={setShowModal}>
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <TableSpesialisNotInJasa
            rows={rows}
            setNewData={setNewAll}
            jasaID={jasaID}
          />
        </Grid>
        <Grid item sm={6}>
          <TableSpesialisInJasa
            rows={rowsSpesialisMapping}
            setNewData={setNewAll}
            jasaID={jasaID}
          />
        </Grid>
      </Grid>
    </Modal>
  );
}

const TableSpesialisNotInJasa = ({ rows, setNewData, jasaID }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "name"],
  });

  const handleClickSelect = async (row) => {
    try {
      const api = await instance3.post(`/master/jasa/jasa_spesialis/register`, {
        id_jasa: jasaID,
        id_spesialis: row.id,
        remark: "-",
      });

      const res = api.data;
      if (res.status === 200) {
        await setNewData();
        defaultToastSuccess("Berhasil menambah spesialis pada jasa ini");
      } else {
        defaultToastError(res.message);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <FreezeTableClient
      title='Daftar Jasa Spesialis'
      setQ={setQ}
      maxHeight='400px'
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRow key={index}>
              <TableCell align='center'>{index + 1}</TableCell>

              <TableCell align='center'>
                <TableAction
                  isUpdate={false}
                  isDelete={false}
                  isSelect={true}
                  clickSelect={() => handleClickSelect(row)}
                />
              </TableCell>

              <TableCell align='left'>{row?.name}</TableCell>
            </TableRow>
          );
        })}
    </FreezeTableClient>
  );
};

const TableSpesialisInJasa = ({ rows, jasaID, setNewData }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "nama_spesialis"],
  });

  const handleClickDelete = async (row) => {
    try {
      const api = await instance3.post(`/master/jasa/jasa_spesialis/delete`, {
        id: row.id,
      });

      const res = api.data;
      if (res.status === 200) {
        await setNewData();
        defaultToastSuccess("Berhasil menambah spesialis pada jasa ini");
      } else {
        defaultToastError(res.message);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <FreezeTableClient
      title='Daftar Spesialis Termaping'
      setQ={setQ}
      maxHeight='400px'
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRow key={index}>
              <TableCell align='center'>{index + 1}</TableCell>

              <TableCell align='center'>
                <TableAction
                  isUpdate={false}
                  isDelete={true}
                  clickDelete={() => handleClickDelete(row)}
                  isSelect={false}
                />
              </TableCell>

              <TableCell align='left'>{row?.nama_spesialis}</TableCell>
            </TableRow>
          );
        })}
    </FreezeTableClient>
  );
};

const getSpesialisNotInJasa = async (jasaID) => {
  try {
    const response = await instance3.get(
      `master/jasa/jasa_spesialis/list-spesialis-not-in-jasa?id_jasa=${jasaID}`
    );
    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.body,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

const getSpesialisInJasa = async (jasaID) => {
  try {
    const response = await instance3.get(
      `master/jasa/jasa_spesialis/list-spesialis-by-jasa?id_jasa=${jasaID}`
    );
    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.body,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "10px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
    width: "10px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "SPESIALIS",
    align: "left",
    sort: false,
  },
];
